import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";
import type { AccountOverviewSharedState } from "../types/state";
import * as ac from "./action-creators";
import initialState from "./initial-state";

const accountOverviewSharedReducer = createReducer<AccountOverviewSharedState, ActionType<typeof ac>>(initialState)
    .handleAction(
        ac.initWithDataAction,
        (state, { payload }): AccountOverviewSharedState => ({
            ...state,
            ...payload,
        }),
    )
    .handleAction(
        ac.countriesIdsSelectedAction,
        (state, { payload }): AccountOverviewSharedState => ({
            ...state,
            selectedCountriesIds: payload.ids,
            selectedWebSourceId: payload.webSourceId ?? state.selectedWebSourceId,
        }),
    )
    .handleAction(
        ac.webSourceIdSelectedAction,
        (state, { payload }): AccountOverviewSharedState => ({
            ...state,
            selectedWebSourceId: payload,
        }),
    )
    .handleAction(
        ac.pageOverlayVisibilityChangedAction,
        (state, { payload }): AccountOverviewSharedState => ({
            ...state,
            isPageOverlayVisible: payload,
        }),
    );

export default accountOverviewSharedReducer;
